// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";

// const Footer = () => {
//   // State to handle form input and alerts
//   const [email, setEmail] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // Handle email change
//   const handleEmailChange = (e) => {
//     setEmail(e.target.value);
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault(); // Prevent default form submission
//     setIsSubmitting(true); // Show "submitting" status

//     try {
//       const response = await fetch(
//         "https://ardorbiomed.com/api/api/Subscribe/",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ email: email }), // Sending email as JSON
//         }
//       );

//       const result = await response.json();

//       if (response.ok) {
//         // Show success alert
//         Swal.fire({
//           icon: "success",
//           title: "Subscribed Successfully",
//           text: "Thank you for subscribing to our newsletter!",
//         });
//       } else {
//         // Show error alert
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Something went wrong. Please try again later.",
//         });
//       }
//     } catch (error) {
//       // Show error alert if API fails
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "An unexpected error occurred. Please try again later.",
//       });
//     } finally {
//       setIsSubmitting(false); // Hide "submitting" status
//     }
//   };

//   return (
//     <div>
//       <section className="newsletter_section newsletter_padding border-top">
//         <div className="container">
//           <div className="row">
//             <div className="col-12">
//               <div className="newsletter_inner d-flex justify-content-between align-items-center">
//                 <div className="newsletter_text">
//                   <h3>Keep connected</h3>
//                   <p>Get updates by subscribing to our weekly newsletter</p>
//                 </div>
//                 <div className="newsletter_subscribe">
//                   <form id="mc-form" onSubmit={handleSubmit}>
//                     <input
//                       className="border-0"
//                       id="mc-email"
//                       type="email"
//                       autocomplete="off"
//                       placeholder="Enter your email address"
//                       value={email}
//                       onChange={handleEmailChange}
//                       required
//                     />
//                     <i className="icon-envelope-open icons"></i>
//                     <button
//                       className="border-0"
//                       id="mc-submit"
//                       disabled={isSubmitting}
//                     >
//                       {isSubmitting ? "Submitting..." : "Subscribe"}
//                     </button>
//                   </form>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>

//       <footer className="footer_widgets">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-5 col-md-5 col-sm-5">
//               <div className="footer_widget_list">
//                 <div className="footer_logo">
//                   <Link to="#">
//                     <img
//                       src="./assets/img/logo/logo-1.png"
//                       alt="Logo"
//                       style={{ height: "100px" }}
//                     />
//                   </Link>
//                 </div>
//                 <div className="footer_contact">
//                   <div className="footer_contact_list">
//                     <span>Our Location</span>
//                     <p>
//                       Ardor Biomed India PVT LTD, Unit No.9, Sakthi Industrial
//                       Estate, Udumalpet Road, Pollachi - 642003.
//                     </p>
//                   </div>
//                   <div className="footer_contact_list">
//                     <span>Mail:</span>
//                     <Link to="mailto:customercare@ardorbiomed.com">
//                       customercare@ardorbiomed.com
//                     </Link>
//                     <br></br>
//                     <Link to="mailto:sales@ardorbiomed.com">
//                       sales@ardorbiomed.com
//                     </Link>
//                   </div>
//                   <div className="footer_contact_list">
//                     <span>24/7 hotline:</span>
//                     <Link to="tel:+91 9488828030">+91 9488828030</Link>
//                     <br></br>
//                     <Link to="tel:+91 9944951234">+91 9944951234</Link>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="col-lg-7 col-md-7 col-sm-7">
//               <div className="footer_widget_list text-right">
//                 <div className="footer_menu">
//                   <ul className="d-flex justify-content-end">
//                     <li>
//                       <Link to="/">Home</Link>
//                     </li>
//                     <li>
//                       <Link to="/Contact">Contact</Link>
//                     </li>
//                     <li>
//                       <Link to="/Cart">Cart</Link>
//                     </li>
//                     <li>
//                       {" "}
//                       <Link to="/Trackorder"> Track Your Order </Link>
//                     </li>
//                   </ul>
//                   <ul className="d-flex justify-content-end">
//                     <li>
//                       <Link to="/AuthForm">SignUp/Login</Link>
//                     </li>
//                     <li>
//                       <Link to="/">Terms & Conditions</Link>
//                     </li>
//                   </ul>
//                 </div>
//                 <div className="footer_social">
//                   <ul className="d-flex justify-content-end">
//                     <li>
//                       <Link
//                         to="https://wa.me/919488828030"
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <i className="ion-social-whatsapp"></i>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="https://twitter.com">
//                         <i className="ion-social-twitter"></i>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="https://www.facebook.com">
//                         <i className="ion-social-facebook"></i>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="https://www.instagram.com">
//                         <i className="ion-social-instagram-outline"></i>
//                       </Link>
//                     </li>
//                     <li>
//                       <Link to="https://www.youtube.com">
//                         <i className="ion-social-youtube"></i>
//                       </Link>
//                     </li>
//                   </ul>
//                 </div>
//                 <div className="copyright_right">
//                   <p>
//                     ©2025 <span>Ardorbiomed</span> made with{" "}
//                     <i className="ion-heart"></i> by{" "}
//                     <Link to="https://hasthemes.com" target="_blank">
//                       Brandingworld
//                     </Link>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default Footer;

import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  // Intersection Observer for scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".scroll-animate").forEach((element) => {
      observer.observe(element);
    });

    return () => {
      document.querySelectorAll(".scroll-animate").forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []);

  return (
    <div
      className="footer-wrapper "
      style={{ boxShadow: "0px 4px 20px rgba(0,0,0,0.2)" }}
    >
      <style jsx>{`
        @keyframes floatIn {
          0% {
            transform: translateY(50px);
            opacity: 0;
          }
          100% {
            transform: translateY(0);
            opacity: 1;
          }
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }

        @keyframes shimmer {
          0% {
            background-position: -100% 0;
          }
          100% {
            background-position: 100% 0;
          }
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes wave {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-15px);
          }
        }

        /* Element Animations */
        .animate-in {
          animation: fadeIn 0.8s ease forwards;
        }

        .scroll-animate {
          opacity: 0;
          transform: translateY(30px);
          transition: opacity 0.8s ease, transform 0.8s ease;
        }

        .scroll-animate.animate-in {
          opacity: 1;
          transform: translateY(0);
        }

        .stagger-item {
          opacity: 0;
          animation: floatIn 0.5s ease forwards;
        }

        .stagger-delay-1 {
          animation-delay: 0.1s;
        }
        .stagger-delay-2 {
          animation-delay: 0.2s;
        }
        .stagger-delay-3 {
          animation-delay: 0.3s;
        }
        .stagger-delay-4 {
          animation-delay: 0.4s;
        }
        .stagger-delay-5 {
          animation-delay: 0.5s;
        }

        .wave-animation {
          animation: wave 3s ease-in-out infinite;
        }

        .pulse-animation {
          animation: pulse 2s infinite;
        }

        .spin-animation {
          animation: spin 10s linear infinite;
        }

        .shimmer-bg {
          background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 0) 0%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0) 100%
          );
          background-size: 200% 100%;
          animation: shimmer 3s infinite;
        }

        .animated-border {
          position: relative;
          overflow: hidden;
        }

        .animated-border::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #4f46e5, transparent);
          animation: shimmer 2s infinite;
        }

        .hover-float {
          transition: transform 0.3s ease;
        }

        .hover-float:hover {
          transform: translateY(-5px);
        }

        .animate-submit {
          animation: pulse 0.5s;
        }

        /* Custom Styling */
        .newsletter-glow {
          box-shadow: 0 0 30px #b4e5a2;
          transition: box-shadow 0.3s ease;
        }

        .newsletter-glow:hover {
          box-shadow: 0 0 50px #6fc54d;
        }

        .gradient-text {
          background: linear-gradient(90deg, #b4e5a2, #6fc54d);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          display: inline-block;
        }

        .gradient-btn {
          background-image: linear-gradient(90deg, #b4e5a2, #6fc54d);
          border: none;
          color: white;
          padding: 7px 24px;
          border-radius: 8px;
          transition: all 0.3s ease;
          font-weight: 600;
        }

         {
          /* .gradient-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px #6fc54d;
        } */
        }

        .wavy-bg {
          position: relative;
          overflow: hidden;
        }

        .wavy-bg::before {
          content: "";
          position: absolute;
          width: 100%;
          height: 15px;
          background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z' opacity='.25' fill='%234f46e5'%3E%3C/path%3E%3Cpath d='M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z' opacity='.5' fill='%234f46e5'%3E%3C/path%3E%3Cpath d='M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z' fill='%234f46e5'%3E%3C/path%3E%3C/svg%3E")
            no-repeat;
          background-size: cover;
          top: 0;
          left: 0;
          z-index: 10;
        }

        .footer-bubble {
          position: absolute;
          background: radial-gradient(circle, #b4e5a2, #6fc54d);
          border-radius: 50%;
          z-index: -1;
          opacity: 0.6;
        }
      `}</style>

      {/* Newsletter Section with Animations */}
      {/* <section
        className="newsletter-section py-5 position-relative overflow-hidden"
        style={{
          background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8ef 100%)",
        }}
      >
        <div className="container position-relative" style={{ zIndex: 5 }}>
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div
                className={`newsletter-card newsletter-glow rounded-lg p-5 bg-white scroll-animate ${
                  animateIn ? "animate-in" : ""
                }`}
                style={{ borderRadius: "16px" }}
              >
                <div className="row align-items-center">
                  <div className="col-lg-6 mb-4 mb-lg-0">
                    <div className="newsletter-content">
                      <h3 className="fw-bold mb-3 gradient-text pulse-animation">
                        Stay Connected
                      </h3>
                      <p className="text-muted mb-0 stagger-item stagger-delay-1">
                        Get exclusive updates and offers directly to your inbox.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <form
                      id="mc-form"
                      onSubmit={handleSubmit}
                      className="newsletter-form stagger-item stagger-delay-2"
                    >
                      <div className="input-group animated-border">
                        <input
                          className="form-control py-3 px-4"
                          style={{
                            borderRadius: "8px 0 0 8px",
                            border: "2px solid #e2e8f0",
                            borderRight: "none",
                          }}
                          id="mc-email"
                          type="email"
                          autoComplete="off"
                          placeholder="Enter your email address"
                          value={email}
                          onChange={handleEmailChange}
                          required
                        />
                        <button
                          className="gradient-btn"
                          id="mc-submit"
                          disabled={isSubmitting}
                          type="submit"
                        >
                          {isSubmitting ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              Sending...
                            </>
                          ) : (
                            <span className="d-flex align-items-center">
                              Subscribe
                              <i className="ion-paper-airplane ms-2"></i>
                            </span>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

       
      </section> */}

      {/* Main Footer with Animations */}
      <footer
        className="main-footer py-5 position-relative"
        style={{
          background: "linear-gradient(135deg, #fff 0%, #fff 100%)",
        }}
      >
        <div className="container position-relative">
          <div className="row">
            {/* Company Info Column */}
            <div className="col-lg-4 mb-5 mb-lg-0 scroll-animate">
              <div className="footer-brand mb-4 wave-animation">
                <Link to="/" className="d-inline-block">
                  <img
                    src="./assets/img/logo/logo-1.png"
                    alt="Ardor Biomed Logo"
                    className="img-fluid"
                    style={{
                      height: "90px",
                      filter: "drop-shadow(0 0 10px rgba(255,255,255,0.3))",
                    }}
                  />
                </Link>
              </div>
              <p className="mb-4 text-black stagger-item stagger-delay-1">
                Pioneering biomedical solutions with innovation and excellence
                to enhance healthcare quality worldwide.
              </p>
              <div className="social-icons-container stagger-item stagger-delay-2">
                <h5 className="text-black mb-3">Connect With Us</h5>
                <ul className="social-icons d-flex list-unstyled">
                  <li className="me-3">
                    <Link
                      to="https://wa.me/919488828030"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="social-icon-link hover-float"
                    >
                      <div
                        className="social-icon d-flex justify-content-center align-items-center"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.1)",
                        }}
                      >
                        <i className="ion-social-whatsapp text-black fs-4"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="me-3">
                    <Link
                      to="https://twitter.com"
                      className="social-icon-link hover-float"
                    >
                      <div
                        className="social-icon d-flex justify-content-center align-items-center"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.1)",
                        }}
                      >
                        <i className="ion-social-twitter text-black fs-4"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="me-3">
                    <Link
                      to="https://www.facebook.com"
                      className="social-icon-link hover-float"
                    >
                      <div
                        className="social-icon d-flex justify-content-center align-items-center"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.1)",
                        }}
                      >
                        <i className="ion-social-facebook text-black fs-4"></i>
                      </div>
                    </Link>
                  </li>
                  <li className="me-3">
                    <Link
                      to="https://www.instagram.com"
                      className="social-icon-link hover-float"
                    >
                      <div
                        className="social-icon d-flex justify-content-center align-items-center"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.1)",
                        }}
                      >
                        <i className="ion-social-instagram-outline text-black fs-4"></i>
                      </div>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://www.youtube.com"
                      className="social-icon-link hover-float"
                    >
                      <div
                        className="social-icon d-flex justify-content-center align-items-center"
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.1)",
                        }}
                      >
                        <i className="ion-social-youtube text-black fs-4"></i>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Quick Links Column */}
            <div className="col-lg-3 col-md-6 mb-5 mb-md-0 scroll-animate">
              <div
                className="footer-links-container animated-border p-4"
                style={{
                  background: "rgba(255,255,255,0.05)",
                  borderRadius: "12px",
                }}
              >
                <h5 className="text-black mb-4 gradient-text">Quick Links</h5>
                <ul className="footer-links list-unstyled">
                  {[
                    {
                      path: "/",
                      label: "Home",
                      icon: "ion-ios-home-outline",
                      delay: 1,
                    },
                    {
                      path: "/Contact",
                      label: "Contact",
                      icon: "ion-ios-email-outline",
                      delay: 2,
                    },
                    {
                      path: "/Cart",
                      label: "Cart",
                      icon: "ion-ios-cart-outline",
                      delay: 3,
                    },
                    {
                      path: "/Trackorder",
                      label: "Track Order",
                      icon: "ion-location",
                      delay: 4,
                    },
                    {
                      path: "/AuthForm",
                      label: "SignUp/Login",
                      icon: "ion-person",
                      delay: 5,
                    },
                    {
                      path: "/TermsAndConditions",
                      label: "Terms & Conditions",
                      icon: "ion-document-text",
                      delay: 6,
                    },
                    {
                      path: "/Refundpolicy",
                      label: "Returns & Refunds",
                      icon: "ion-document-text",
                      delay: 7,
                    },
                  ].map((link, index) => (
                    <li
                      key={index}
                      className={`mb-3 stagger-item stagger-delay-${link.delay}`}
                    >
                      <Link
                        to={link.path}
                        className="text-black text-decoration-none hover-float d-block p-2"
                        style={{ transition: "all 0.3s ease" }}
                      >
                        <div className="d-flex align-items-center">
                          <i className={`${link.icon} me-2`}></i>
                          <span>{link.label}</span>
                          <div
                            className="ms-auto shimmer-bg"
                            style={{
                              width: "5px",
                              height: "5px",
                              borderRadius: "50%",
                              opacity: "0.5",
                            }}
                          ></div>
                        </div>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Contact Information Column */}
            <div className="col-lg-5 col-md-6 scroll-animate">
              <div
                className="contact-info-container p-4"
                style={{
                  background: "rgba(255,255,255,0.05)",
                  borderRadius: "12px",
                }}
              >
                <h5 className="text-black mb-4 gradient-text">
                  Contact Information
                </h5>

                <div className="contact-item mb-4 d-flex stagger-item stagger-delay-1 hover-float">
                  <div
                    className="contact-icon d-flex justify-content-center align-items-center me-3"
                    style={{
                      width: "80px",
                      height: "50px",
                      borderRadius: "12px",
                      background: "#b4e5a2",
                    }}
                  >
                    <i className="ion-ios-location text-black fs-4"></i>
                  </div>
                  <div>
                    <h6 className="text-black mb-2">Visit Our Office</h6>
                    <p className="mb-0 text-black" style={{ opacity: "0.7" }}>
                      Ardor Biomed India PVT LTD, Unit No.9, Sakthi Industrial
                      Estate, Udumalpet Road, Pollachi - 642003.
                    </p>
                  </div>
                </div>

                <div className="contact-item mb-4 d-flex stagger-item stagger-delay-2 hover-float">
                  <div
                    className="contact-icon d-flex justify-content-center align-items-center me-3"
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "12px",
                      background: "#b4e5a2",
                    }}
                  >
                    <i className="ion-ios-email text-black fs-4"></i>
                  </div>
                  <div>
                    <h6 className="text-black mb-2">Email Us</h6>
                    <p className="mb-0" style={{ opacity: "0.7" }}>
                      <Link
                        to="mailto:customercare@ardorbiomed.com"
                        className="text-black text-decoration-none d-block mb-1"
                      >
                        customercare@ardorbiomed.com
                      </Link>
                      <Link
                        to="mailto:sales@ardorbiomed.com"
                        className="text-black text-decoration-none"
                      >
                        sales@ardorbiomed.com
                      </Link>
                    </p>
                  </div>
                </div>

                <div className="contact-item d-flex stagger-item stagger-delay-3 hover-float">
                  <div
                    className="contact-icon d-flex justify-content-center align-items-center me-3 pulse-animation"
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "12px",
                      background: "#b4e5a2",
                    }}
                  >
                    <i className="ion-ios-telephone text-black fs-4"></i>
                  </div>
                  <div>
                    <h6 className="text-black mb-2">Call Us 24/7</h6>
                    <p className="mb-0" style={{ opacity: "0.7" }}>
                      <Link
                        to="tel:+91 9488828030"
                        className="text-black text-decoration-none d-block mb-1"
                      >
                        +91 9488828030
                      </Link>
                      <Link
                        to="tel:+91 9944951234"
                        className="text-black text-decoration-none"
                      >
                        +91 9944951234
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Animated Copyright Section */}
      <div
        className="copyright-section py-3 text-center shimmer-bg"
        style={{ background: "#fff" }}
      >
        <div className="container">
          <p className="mb-0 text-black stagger-item">
            ©2025 <span className="fw-bold gradient-text">Ardorbiomed</span>{" "}
            made with Powered by{" "}
            <Link
              to="https://brandingworld.net/"
              target="_blank"
              className="text-decoration-none"
            >
              <span
                className="gradient-text hover-float"
                style={{ display: "inline-block" }}
              >
                Brandingworld
              </span>
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
